export default __webpack_public_path__ + "static/media/soglasie.d1c71928.svg";